export default "__VITE_ASSET__07f9e998__"